@if (typingAdmins.length > 0) {
  <div margin-tb-small padding-left>
    <rt-note-typing-indicator-message [typingAdmins]="typingAdmins" />
  </div>
}

@for (note of sortedNotes; track trackByNote($index, note)) {
  <rt-note-item
    #noteRef
    [attr.data-id]="note.id"
    [note]="note"
    [allNotesFlat]="allNotesFlat"
    [privateContext]="note.private!"
    [editing]="notesBeingEdited().includes(note.id!)"
    [replying]="notesBeingRepliedTo().includes(note.id!)"
    [cachedReply]="cachedReply!"
    [currentlyTypedNotes]="currentlyTypedNotes()"
    [noteSaveLoading]="notesBeingSaved()"
    [notesDeleteLoading]="notesBeingDeleted()"
    [noteAttachmentLoading]="noteAttachmentsBeingUploaded()"
    [canDeleteAttachments]="canDeleteAttachments()"
    [canHighLevelDataAccess]="canHighLevelDataAccess()"
    [notesBeingEdited]="notesBeingEdited()"
    [notesBeingRepliedTo]="notesBeingRepliedTo()"
    [attachmentsTemp]="noteAttachmentsTemp()"
    [isReadOnly]="isReadOnly()"
    [isOwnerFn]="isOwnerFn()"
    [getOwnerFn]="getOwnerFn()"
    [localStorageKeyBuilder]="localStorageKeyBuilder()"
    [noteToMention]="noteToMention()"
    [isAutomatedActionNoteFn]="isAutomatedActionNoteFn()"
    [visibilitySelectorComponent]="visibilitySelectorComponent()"
    [visibilityComponentInputs]="visibilityComponentInputs()"
    [canReply]="canReply()"
    [canPin]="canPin()"
    [hasFileUpload]="hasFileUpload()"
    [hasReactions]="hasReactions()"
    (replyTypingStart)="replyTypingStart.emit($event)"
    (replyTypingFinish)="replyTypingFinish.emit()"
    (replyChanges)="setCachedReply($event)"
    (noteDiscardClick)="noteDiscardClick.emit($event)"
    (noteSaveClick)="noteSaveClick.emit($event)"
    (noteChecklistClick)="noteChecklistClick.emit($event)"
    (noteDeleteClick)="noteDeleteClick.emit($event)"
    (notePinClick)="notePinClick.emit($event)"
    (noteUnpinClick)="noteUnpinClick.emit($event)"
    (noteEditClick)="noteEditClick.emit($event)"
    (noteReplyClick)="noteReplyClick.emit($event)"
    (uploadAttachmentClick)="uploadAttachmentClick.emit($event)"
    (deleteAttachmentClick)="deleteAttachmentClick.emit($event)"
  />
}
